import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        routeLoading: false,
    },
    mutations: {
        changeRouteLoading(state, arg) {
            console.log({state,arg});
            state.routeLoading = arg;
        },
    },
    actions: {},
    modules: {},
});
